var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmoneygroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#E7F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1669 16.0001C19.1669 16.5275 19.0105 17.0431 18.7175 17.4816C18.4245 17.9201 18.0081 18.2619 17.5208 18.4637C17.0335 18.6656 16.4974 18.7184 15.9801 18.6155C15.4628 18.5126 14.9877 18.2586 14.6147 17.8857C14.2418 17.5127 13.9878 17.0376 13.885 16.5203C13.7821 16.0031 13.8349 15.4669 14.0367 14.9796C14.2385 14.4924 14.5803 14.0759 15.0188 13.7829C15.4574 13.4899 15.9729 13.3335 16.5003 13.3335C17.2076 13.3335 17.8858 13.6144 18.3859 14.1145C18.886 14.6146 19.1669 15.2929 19.1669 16.0001ZM24.5002 11.2335V20.7667C24.5002 20.9081 24.444 21.0438 24.344 21.1438C24.2439 21.2438 24.1083 21.3 23.9668 21.3H9.03381C8.89236 21.3 8.75671 21.2438 8.65669 21.1438C8.55668 21.0438 8.50049 20.9081 8.50049 20.7667V11.2335C8.50049 11.0921 8.55668 10.9564 8.65669 10.8564C8.75671 10.7564 8.89236 10.7002 9.03381 10.7002H23.9668C24.1083 10.7002 24.2439 10.7564 24.344 10.8564C24.444 10.9564 24.5002 11.0921 24.5002 11.2335ZM23.4335 14.8235C22.8279 14.6444 22.2768 14.3167 21.8302 13.8701C21.3837 13.4236 21.056 12.8724 20.8769 12.2668H12.1237C11.9447 12.8724 11.617 13.4236 11.1704 13.8701C10.7239 14.3167 10.1727 14.6444 9.56713 14.8235V17.1767C10.1727 17.3558 10.7239 17.6835 11.1704 18.1301C11.617 18.5766 11.9447 19.1278 12.1237 19.7334H20.8769C21.056 19.1278 21.3837 18.5766 21.8302 18.1301C22.2768 17.6835 22.8279 17.3558 23.4335 17.1767V14.8235Z",
    fill: "#1271FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmoneygroup);
export default __webpack_public_path__ + "static/media/icon.money.group.534f7687d8b7cfb8996b6e4e0fe63ffb.svg";
export { ForwardRef as ReactComponent };